(ns frontend.ui.component.lp-portal.report.body.invest-europe.fund.pdf-pages.fund-information
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.column.pdf.view :as column-types]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [potpuri.core :as potpuri]))

(defn fund-information-page-center
  [{:keys [fund-information] :as data}]
  [(card/card
    "Historical fund performance"
    {:svg   (chart-view/chart-svg "highcharts"

                                  (potpuri/deep-merge (-> data
                                                          :fund-information
                                                          :historical-fund-performance
                                                          :figures)
                                                      {:chart {:width  500
                                                               :height 350}}))
     :width 250}
    (text-content/optional-footer (:historical-fund-performance fund-information)))])

(defn fund-information-page-left
  [{:keys [fund-information] :as data}]
  [(card/card
    "Value progression"
    {:svg   (chart-view/chart-svg "highcharts"

                                  (potpuri/deep-merge (-> data
                                                          :fund-information
                                                          :value-progression
                                                          :figures)
                                                      {:chart {:width  500
                                                               :height 350}}))
     :width 250}
    (text-content/optional-footer (:value-progression fund-information)))
  ])

(defn fund-information-page-right
  [{:keys [fund-information] :as data}]
  [(card/card
    "Fund value bridge"
    {:svg   (chart-view/chart-svg "highcharts"

                                  (potpuri/deep-merge (-> data
                                                          :fund-information
                                                          :fund-value-bridge
                                                          :figures)
                                                      {:chart {:width  500
                                                               :height 350}}))
     :width 250}
    (text-content/optional-footer (:fund-value-bridge fund-information)))
  ])
(defn fund-information-page
  [data]
  (page/page
   (page/page-title {:fund-name  (:fund-name data)
                     :page-title "Fund information"
                     :toc-item   true})
   (column-types/columns
    (fund-information-page-left data)
    (fund-information-page-center data)
    (fund-information-page-right data))))


